/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityBatchTrxSummaryInfo = {
    BTNO: string;
    CMTRX: string;
    L1BN: string;
    BS: HumanityBatchTrxSummaryInfo.BS;
};

export namespace HumanityBatchTrxSummaryInfo {

    export enum BS {
        FINALIZED = 'FINALIZED',
        UNFILALIZED = 'UNFILALIZED',
    }


}

